import React from "react";
import "../Assets/css/index.css";
function CopyRights() {
  return <div>CopyRIght</div>;
}

export default CopyRights;
